export default {
  productId: {
    id: 'buyback_refurbisher_search_product_id_label',
    defaultMessage: 'BackMarket ID: {id}',
  },
  moreDetails: {
    id: 'buyback_refurbisher_search_product_more_details',
    defaultMessage: 'More details',
  },
  attributes: {
    id: 'buyback_refurbisher_search_product_attributes',
    defaultMessage: 'Attributes',
  },
  specifications: {
    id: 'buyback_refurbisher_search_product_specifications',
    defaultMessage: 'Specifications',
  },
  buyItem: {
    id: 'buyback_refurbisher_search_product_buy_item',
    defaultMessage: 'Buy item',
  },
}
